import { StateCreator } from 'zustand';
import { PanelDefinition } from '../../../core';
import { Middleware } from './common';

/**
 * Slice with the state of Panels, along with any actions that modify only the Panels state.
 */
export interface PanelSlice {
  panels: Record<string, PanelDefinition>;
}

/**
 * Curried function for creating the PanelSlice.
 */
export function createPanelSlice(panels: PanelSlice['panels']): StateCreator<PanelSlice, Middleware, [], PanelSlice> {
  return () => ({
    panels,
  });
}
